import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Fund Tags Associations API
 */
class FundTagsAssociationsApi extends ApiBase {
  /**
   * create fundtags/associations relations
   * @param {*} ids List of fundTagId/fundId
   */
  async create(payload) {
    const request = {
      url: `${this.API_URL}/fundtags/associations`,
      headers: this.getHeaders(),
      method: 'POST',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * delete fundtags/associations relations
   * @param {*} ids List of fundTagId/fundId
   */
  async delete(payload) {
    const request = {
      url: `${this.API_URL}/fundtags/associations`,
      headers: this.getHeaders(),
      method: 'DELETE',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  }
}

export default new FundTagsAssociationsApi();
